import { CreateElement } from '@src/vue'

import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'

import { Element } from '@src/mixins/element/element'

import './select.sass'

@Component
export class OptionGroup extends Mixins<Element>(Element) {

  @Prop({ required: false })
  extraStyles: object

  render (h: CreateElement) {
    return <div class={'option-group-wrapper'}>
      <div class={'option-group'} style={this.extraStyles}>
        {this.$slots.default}
      </div>
    </div>
  }

}
